export class CwjProjectRuntimeError extends Error {
    constructor(message, code) {
        super(message);
        this.code = code;
        this.name = "CwjProjectRuntimeError";
    }
}
//# sourceMappingURL=types.js.map